module.exports = __webpack_public_path__ + "img/5.ac5e58b5.png";